import React from 'react'
import { Tabs, Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import StatementsFilters from './StatementsFilters'
import ChargesFilters from './ChargesFilters'
import OrderSummaryFilters from './OrderSummaryFilters'
import CommonReports from './CommonReports'
import FranchiseFilters from './FranchiseFilters'
import PayoutReconciliationFilters from './PayoutReconciliationFilters'

const { TabPane } = Tabs

interface ReportProps {
  merchant: {
    setting: {
      franchise_enabled: boolean
    }
  }
  reportTab?: string
}

const Reports = ({ merchant, reportTab }: ReportProps) => {
  const history = useHistory()

  const activeTabKey = reportTab || 'statements'

  const handleTabChange = (activeKey: string) => {
    history.push(`/orders/generate-report/${activeKey}`)
  }

  return (
    <div>
      <Tabs size='small' activeKey={activeTabKey} onChange={handleTabChange}>
        <TabPane
          tab={
            <>
              Statements
              <Tooltip
                title={
                  <span>
                    Statements provide a full breakdown of orders, sales and
                    fees. Learn more{' '}
                    <a
                      href='https://support.slerp.com/en_gb/statements-r1r6Cj46u'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      here
                    </a>
                    .
                  </span>
                }
                placement='right'
              >
                <QuestionCircleOutlined className='_ml-8' />
              </Tooltip>
            </>
          }
          key='statements'
        >
          <StatementsFilters />
        </TabPane>
        <TabPane
          tab={
            <>
              Order Summary
              <Tooltip
                title={
                  <span>
                    Learn how to customise your reports{' '}
                    <a
                      href='https://support.slerp.com/en_us/filtering-downloading-reports-r1qDEu9ZK'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      here
                    </a>
                    .
                  </span>
                }
                placement='right'
              >
                <QuestionCircleOutlined className='_ml-8' />
              </Tooltip>
            </>
          }
          key='order-summary'
        >
          <OrderSummaryFilters />
        </TabPane>
        <TabPane tab='Reports' key='reports'>
          <CommonReports />
        </TabPane>
        {merchant?.setting?.franchise_enabled && (
          <TabPane
            tab='Franchise Payment Transfers'
            key='franchise-payment-transfers'
          >
            <FranchiseFilters />
          </TabPane>
        )}
        <TabPane
          tab={
            <>
              Additional Charges
              <Tooltip
                title={
                  <span>
                    Additional charges may apply, particularly if an action is
                    taken post-purchase. These are summarised in this report.
                  </span>
                }
                placement='right'
              >
                <QuestionCircleOutlined className='_ml-8' />
              </Tooltip>
            </>
          }
          key='additional-charges'
        >
          <ChargesFilters />
        </TabPane>
        <TabPane
          tab={
            <>
              Payout Reconciliation
              <Tooltip
                title={
                  <span>
                    Payout Reconciliation report provides a breakdown of
                    transactions linked to each Stripe payout.
                  </span>
                }
                placement='right'
              >
                <QuestionCircleOutlined className='_ml-8' />
              </Tooltip>
            </>
          }
          key='payout-reconciliation'
        >
          <PayoutReconciliationFilters />
        </TabPane>
      </Tabs>
    </div>
  )
}

export default Reports
